import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-leblon.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const Leblon = () => (
  <NeighborhoodPage
    name="Leblon"
    slug="leblon"
    description="O metro quadrado mais valorizado do Rio de Janeiro. Exclusividade, gastronomia de primeira e qualidade de vida incomparável."
    heroPicture={heroImage}
  />
);

export default Leblon;
